module.exports = __webpack_public_path__ + "src/assets/img/XADABath.4ef29464.jpg";